module.exports = __webpack_public_path__ + "img/CNlogo@2x.e6009358.png";